import React from 'react';
import { useEditorContext } from '../../../../components/Editor/Context';
import { isTouch } from '../../../../components/utils/browser';
import BlockBubbleMenu from '../../../../components/menus/BlockBubbleMenu';
import Delete from '../buttons/Delete';
import { DaVideoOptions } from '../../daVideo';
import {
  getExtensionOptions,
  shouldBlockMenuBeOpen,
} from '../../../../components/utils/tiptap';
import Alignment from '../buttons/Alignment';
import Edit from '../buttons/Edit';
import cn from 'classnames';

interface Props {
  scrollContainerRef?: React.RefObject<HTMLElement | null>;
}

const MenuButtons: React.FC<any> = ({ editor, forMobile = false }) => {
  const options: DaVideoOptions = getExtensionOptions(editor, 'da-video');
  return (
    <div
      className={cn(!forMobile && 'ds-surface-tertiary')}
      style={{ maxWidth: '100vw', display: 'flex', flexWrap: 'wrap' }}
    >
      {options.canAlign && <Alignment editor={editor} />}
      <Edit editor={editor} />
      <Delete editor={editor} />
    </div>
  );
};

const DaVideoBubbleMenu: React.FC<Props> = ({ scrollContainerRef }) => {
  const editor = useEditorContext();

  if (!editor) {
    return null;
  }

  if (!editor?.isEditable || isTouch()) {
    return null;
  }

  const open = shouldBlockMenuBeOpen(editor, 'da-video');

  let buttonCount = 3;

  const options: DaVideoOptions = getExtensionOptions(editor, 'da-video');
  if (!options.canAlign) {
    buttonCount--;
  }

  return (
    <BlockBubbleMenu
      scrollContainerRef={scrollContainerRef}
      menuHeight={38}
      menuWidth={40 * buttonCount}
      editor={editor}
      open={open}
      childSelector=".main-video"
    >
      <MenuButtons editor={editor} />
    </BlockBubbleMenu>
  );
};
DaVideoBubbleMenu.displayName = 'DaVideoBubbleMenu';

export default DaVideoBubbleMenu;
export { MenuButtons };
